import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import { Cashdesk, CashdeskRegistryFilters, createCashdeskRegistryQuery } from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel, SORT_DIRECTIONS } from 'shared/lib';

type CreateCashdeskRegistryModelParams = {
	currencies: Store<string[]>;
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export type CashdeskRegistryModel = {
	model: RegistryModel<Cashdesk, CashdeskRegistryFilters, JsonApiRequestError>;
	currencies: Store<string[]>;
};

export const createCashdeskRegistryModel = ({
	currencies,
	$accountId,
	...params
}: CreateCashdeskRegistryModelParams): CashdeskRegistryModel => {
	const query = createCashdeskRegistryQuery($accountId);

	const model = createRegistryModel({
		query,
		filters: {
			name: '',
			currencies: [],
			accountIds: [],
		},
		sortField: 'name',
		sortDirection: SORT_DIRECTIONS.ASC,
		...params,
	});

	return { model, currencies };
};
